import { render, staticRenderFns } from "./editNotifications.vue?vue&type=template&id=76749f34&scoped=true&lang=pug"
import script from "./editNotifications.vue?vue&type=script&lang=js"
export * from "./editNotifications.vue?vue&type=script&lang=js"
import style0 from "./editNotifications.vue?vue&type=style&index=0&id=76749f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76749f34",
  null
  
)

export default component.exports